import { FC, useEffect, useState } from "react";
import useCustomTranslation from "../hooks/CustomUseTranslation";
import styled from "styled-components";
import { OpenApiRequestStatus, useOpenApiRequest } from "typescript-request-utils";

import { UserCustomer } from "../../api/models/UserCustomer";
import { TableColumn, TableRow } from "../../framework/components/table/tableComponents";
import { getApiRegistry } from "../../framework/state/apiRegistry";
import { DeclineIcon } from "../../framework/components/modal/modalIcons";
import UserCustomerModal from "../../framework/components/modal/UserCustomerModal";
import { relationToString } from "../../api/enums/Relation";
import { ViewType } from "../../page/enums/ViewType";
import { representationIsEnding } from "../../utilities/RepresentationUtil";

const ActionButton = styled.button`
    margin-left: 10px;
    border: 1.5px solid;
    border-color: #e57373;
    border-radius: 5px;
    background-color: white;
    height: 30px;
    width: 30px;
    padding: 0;
    float: right;
`

const RenewCheckbox = styled.input`
    height: 30px;
    width: 30px;
`

const EndingRepresentationMarker = styled.div`
    height: 10px;
    width: 10px;
    border-radius: 50%;
    background-color: red;
    margin-left: 10px;
`

export interface UserCustomerProps {
    userCustomer: UserCustomer;
    type: ViewType;
    onUpdate: () => void;
}

const UserCustomerItem: FC<UserCustomerProps> = (props) => {
    const [showModal, setShowModal] = useState<boolean>(false);
    const [deleteError, setDeleteError] = useState<boolean>(false);
    const [deleteUserCustomerPending, setDeleteUserCustomerPending] = useState<boolean>(false);
    const [deleteUserCustomerRequest, deleteUserCustomer] = useOpenApiRequest(getApiRegistry().userCustomerApi.delete);
    const [updateUserCustomerRequst, updateUserCustomer] = useOpenApiRequest(getApiRegistry().userCustomerApi.update);

    const { t } = useCustomTranslation();
    var startDate = props.userCustomer.startDate ? props.userCustomer.startDate.toLocaleDateString("fi-FI") : '';
    var endDate = props.userCustomer.endDate ? props.userCustomer.endDate.toLocaleDateString("fi-FI") : '';
    const represenatationIsEnding = representationIsEnding(props.userCustomer);

    useEffect(() => {
        if (deleteUserCustomerRequest.type === OpenApiRequestStatus.Pending) {
            setDeleteUserCustomerPending(true);
        }
        if (deleteUserCustomerRequest.type === OpenApiRequestStatus.Complete) {
            setShowModal(false);
            setDeleteError(false);
            setDeleteUserCustomerPending(false);
            props.onUpdate();
        } else if (deleteUserCustomerRequest.type === OpenApiRequestStatus.NetworkError || deleteUserCustomerRequest.type === OpenApiRequestStatus.ServerError) {
            setDeleteError(true);
            setDeleteUserCustomerPending(false);
        }
        // eslint-disable-next-line
    }, [deleteUserCustomerRequest]);

    useEffect(() => {
        if (!showModal) {
            setDeleteError(false);
        }
    }, [showModal]);

    return (
        <TableRow>
            {props.type === ViewType.AUTHORIZED_USERS &&
                <TableColumn>{props.userCustomer.user?.username}</TableColumn>
            }
            <TableColumn>{props.userCustomer.customer?.customerNumber}</TableColumn>
            <TableColumn>{props.userCustomer.customer?.name}</TableColumn>
            <TableColumn> 
                <div style={{ display: 'flex', alignItems: 'center' }}>
                {startDate} - {endDate}
                {
                    represenatationIsEnding && (props.type === ViewType.AUTHORIZED_USERS || props.type === ViewType.CUSTOMER_AUTHORIZATIONS) &&
                    <EndingRepresentationMarker/>
                }
                </div>
            </TableColumn>
            {props.type === ViewType.CUSTOMER_AUTHORIZATIONS &&
                <TableColumn>{t(relationToString(props.userCustomer.relation))}</TableColumn>
            }
            {props.type === ViewType.AUTHORIZED_USERS &&
                <TableColumn>
                    <RenewCheckbox type="checkbox" checked={props.userCustomer.autorenewal} onChange={() => handleRenewalChange()}/>
                </TableColumn>
            }
            <TableColumn style={{ 'width': '50px' }}>
                <ActionButton 
                    aria-labelledby="removeUserCustomerButton" 
                    id="removeUserCustomerButton" 
                    onClick={() => setShowModal(true)}>
                    <DeclineIcon />
                </ActionButton>
                <UserCustomerModal
                    show={showModal}
                    userCustomer={props.userCustomer}
                    showModal={setShowModal}
                    handleClick={deleteUserCustomer}
                    showError={deleteError}
                    deleteUserCustomerPending={deleteUserCustomerPending} />
            </TableColumn>
        </TableRow>
    )

    function handleRenewalChange() {
        props.userCustomer.autorenewal = !props.userCustomer.autorenewal;
        updateUserCustomer(props.userCustomer);
    }
}

export default UserCustomerItem;